/* eslint-disable operator-linebreak */
/* eslint-disable semi */
/* eslint-disable max-len */
// ==========================================================================
// FUNZIONE DI CALCOLO DEL TEMPO STIMATO PER LA CONSEGNA
// --------------------------------------------------------------------------
// Versione comprendente il controllo dei sabati e delle domeniche in cui i
// corrieri non viaggiano, ritardando quindi la data prevista di consegna
// di 2 giorni
// ==========================================================================
function estimateDelivery(days, language, startdate) {
  let counter = days

  // definisco un array di mesi e un array di giorni in lingua
  let mese = {}
  let giorno = {}

  if (language === 'it') {
    mese = {
      1: 'gennaio',
      2: 'febbraio',
      3: 'marzo',
      4: 'aprile',
      5: 'maggio',
      6: 'giugno',
      7: 'luglio',
      8: 'agosto',
      9: 'settembre',
      10: 'ottobre',
      11: 'novembre',
      12: 'dicembre',
    }
    giorno = {
      0: 'Domenica',
      1: 'Lunedi',
      2: 'Martedi',
      3: 'Mercoledi',
      4: 'Giovedi',
      5: 'Venerdi',
      6: 'Sabato',
    }
  } else if (language === 'en') {
    mese = {
      1: 'January',
      2: 'February',
      3: 'March',
      4: 'April',
      5: 'May',
      6: 'June',
      7: 'July',
      8: 'August',
      9: 'September',
      10: 'October',
      11: 'November',
      12: 'December',
    }
    giorno = {
      0: 'Sunday',
      1: 'Monday',
      2: 'Tuesday',
      3: 'Wednesday',
      4: 'Thursday',
      5: 'Friday',
      6: 'Saturday',
    }
  }

  // creo la data e inserisco il valore numerico del giorno della
  // settimana all'interno della variabile di controllo. Definisco anche
  // l'oggetto su cui eseguirò il controllo delle festivita' italiane fisse.

  let consegna
  if (startdate === 1) {
    consegna = new Date('8/30/2021')
  } else {
    consegna = new Date()
  }

  const feste = new Date()
  let controllo = consegna.getDay()

  // Se l'orario è oltre le 14 aggiungo 1 al counter per far partire
  // il conteggio dal giorno successivo (14/05/2018 - impostato alle 13)
  if (startdate !== 1 && consegna.getHours() > 12) {
    counter += 1
  }

  // Eseguo il controllo dei giorni con valore 6 e 0 equivalenti ai
  // sabati e alle domeniche in cui i corrieri non consegnano ed
  // incremento il counter della tempistica di consegna
  for (let i = 0; i < counter; i += 1) {
    // controllo se è sabato e incremento il conteggio giorni
    // dopo resetto la variabile di controllo al giorno successivo
    // 0 = domenica
    if (controllo === 6) {
      counter += 1
      controllo = 0
      // incremento il controllo festivita'
      feste.setDate(feste.getDate() + 1)

      // controllo se è domenica e incremento il conteggio giorni
      // dopo resetto la variabile di controllo al giorno successivo
      // 1 = lunedì
    } else if (controllo === 0) {
      counter += 1
      controllo = 1
      // incremento il controllo festivita'
      feste.setDate(feste.getDate() + 1)

      // giorno lavorativo procedo solo ad incrementare la variabile
      // di controllo per il giorno successivo e controllo se è una
      // festività del calendario italiano, nel caso aumento counter
    } else {
      // eseguo il controllo delle festività partendo dal mese
      switch (feste.getMonth() + 1) {
        // GENNAIO - primo dell'anno ed epifania
        case 1:
          if (feste.getDate() === 1 || feste.getDate() === 6) {
            counter += 1
          }
          break
        // APRILE - 25 Aprile
        case 4:
          if (feste.getDate() === 25) {
            counter += 1
          }
          break
        // MAGGIO - Primo Maggio
        case 5:
          if (feste.getDate() === 1) {
            counter += 1
          }
          break
        // GIUGNO - 2 Giugno
        case 6:
          if (feste.getDate() === 2) {
            counter += 1
          }
          break
        // AGOSTO - Ferragosto
        case 8:
          if (feste.getDate() === 15) {
            counter += 1
          }
          break
        // NOVEMBRE - Primo Novembre
        case 11:
          if (feste.getDate() === 1) {
            counter += 1
          }
          break
        // DICEMBRE - 8 Dicembre, Natale e Santo Stefano
        case 12:
          if (
            feste.getDate() === 8 ||
            feste.getDate() === 25 ||
            feste.getDate() === 26
          ) {
            counter += 1
          }
          break
        default:
      }

      controllo += 1

      // incremento il controllo festività
      feste.setDate(feste.getDate() + 1)
    }
  }

  // Inserisco la nuova data di consegna prevista nell'oggetto
  // sommando la data odierna con il counter aggiornato
  consegna.setDate(consegna.getDate() + counter)

  // if (startdate === 1) {
  //   startdate = new Date('1/7/2021');
  //   const difftime = Math.abs(startdate - consegna);
  //   const diffdays = Math.ceil(difftime / (1000 * 60 * 60 * 24));
  //   console.log(diffdays);

  //   consegna.setDate(consegna.getDate() + diffdays + counter);

  // } else {
  //   consegna.setDate(consegna.getDate() + counter);
  // }

  // Controllo se il risultato finale è un sabato o una domenica e
  // aggiorno la consegna di conseguenza
  if (consegna.getDay() === 0) {
    // domenica
    consegna.setDate(consegna.getDate() + 1)
  } else if (consegna.getDay() === 6) {
    // sabato
    consegna.setDate(consegna.getDate() + 2)
  }

  // Controllo se il risultato finale è una festività e aggiorno
  // la consegna di conseguenza (snippet necessario per le festività presenti
  // subito dopo la domenica o subito dopo un altra festività)
  switch (consegna.getMonth() + 1) {
    // GENNAIO - primo dell'anno ed epifania
    case 1:
      if (consegna.getDate() === 1 || consegna.getDate() === 6) {
        consegna.setDate(consegna.getDate() + 1)
      }
      break
    // APRILE - 25 Aprile
    case 4:
      if (consegna.getDate() === 25) {
        consegna.setDate(consegna.getDate() + 1)
      }
      break
    // MAGGIO - Primo Maggio
    case 5:
      if (consegna.getDate() === 1) {
        consegna.setDate(consegna.getDate() + 1)
      }
      break
    // GIUGNO - 2 Giugno
    case 6:
      if (consegna.getDate() === 2) {
        consegna.setDate(consegna.getDate() + 1)
      }
      break
    // AGOSTO - Ferragosto
    case 8:
      if (consegna.getDate() === 15) {
        consegna.setDate(consegna.getDate() + 1)
      }
      break
    // NOVEMBRE - Primo Novembre
    case 11:
      if (consegna.getDate() === 1) {
        consegna.setDate(consegna.getDate() + 1)
      }
      break
    // DICEMBRE - 8 Dicembre, Natale e Santo Stefano
    case 12:
      // if (
      //   consegna.getDate() === 8 ||
      //   consegna.getDate() === 25 ||
      //   consegna.getDate() === 26
      // ) {
      //   consegna.setDate(consegna.getDate() + 1)
      // }
      if (consegna.getDate() === 8) {
        consegna.setDate(consegna.getDate() + 1)
      }
      if (consegna.getDate() === 25) {
        consegna.setDate(consegna.getDate() + 1)
      }
      if (consegna.getDate() === 26) {
        consegna.setDate(consegna.getDate() + 1)
      }
      break
    default:
  }

  // Controllo nuovamente se il risultato finale è un sabato o una domenica e
  // aggiorno la consegna di conseguenza
  if (consegna.getDay() === 0) {
    // domenica
    consegna.setDate(consegna.getDate() + 1)
  } else if (consegna.getDay() === 6) {
    // sabato
    consegna.setDate(consegna.getDate() + 2)
  }

  // INSERIRE LO SNIPPET DI CODICE PER IL CALCOLO DELLA PASQUA E DELLA
  // PASQUETTA CON RELATIVA COUNTER AGGIORNATO DELLA CONSEGNA

  // recupero le informazioni di giorno, numero giorno e mese
  // e li inserisco nel testo da visualizzare in dettaglio articolo
  const giornonum = consegna.getDay()
  const giornoval = consegna.getDate()
  const mesenum = consegna.getMonth() + 1

  // snippet per il messaggio della consegna nel periodo di Natale
  // if (mesenum === 12) {
  //   if (giornoval < 24) {
  //     $('#xmas-avail-yes').removeClass('hidden')
  //     $('#xmas-avail-yes-mobile').removeClass('hidden')
  //   } else {
  //     $('#xmas-avail-no').removeClass('hidden')
  //   }
  // }
  // Solo per la fine di novembre
  // if (mesenum === 11 && giornoval >= 25 && giornoval <= 30) {
  //   $('#xmas-avail-yes').removeClass('hidden')
  //   $('#xmas-avail-yes-mobile').removeClass('hidden')
  // }

  return giorno[giornonum] + ' ' + giornoval + ' ' + mese[mesenum]
}

// Funzione di messaggio in lingua per pausa estiva
function pausaEstivaMsg(language, days) {
  if (language === 'it') {
    $('#consegna-entro').html(
      'Le consegne per questo articolo riprenderanno dal 28 di agosto, consideri ' +
        days +
        ' per la consegna'
    )
  } else if (language === 'en') {
    $('#consegna-entro').html(
      'Deliveries for this item will resume from 2 september'
    )
  }
}

// Funzione di messaggio in lingua per chiusura Natalizia
// eslint-disable-next-line no-unused-vars
function xmasNoShipMsg(language) {
  if (language === 'it') {
    $('#consegna-entro').html(
      'Le consegne per questo articolo riprenderanno dal 7 di Gennaio a causa della chiusura del fornitore'
    )
  } else if (language === 'en') {
    $('#consegna-entro').html(
      "Deliveries for this item will resume from 7 January due to the supplier's closing"
    )
  }
}

// eslint-disable-next-line wrap-iife, no-extra-semi
;(function () {
  // Prendo la lingua corrente
  const lang = $('html').attr('lang')

  // leggo il dato stampato in scheda articolo nella disponibilità
  // e setto il numero di giorni previsti per la consegna
  let delivery = $('.delivery').text()
  delivery = delivery.trim()

  if (delivery === 'DISPONIBILE' || delivery === 'AVAILABLE') {
    $('.consegna').html(estimateDelivery(1, lang))
    // pausaEstivaMsg(lang, '1 giorno');
  } else if (delivery === '3 / 5 GIORNI' || delivery === 'IMMEDIATA') {
    $('.consegna').html(estimateDelivery(4, lang))
    // pausaEstivaMsg(lang, '3 - 5 giorni');
    // xmasNoShipMsg(lang);
  } else if (delivery === '7 / 10 GIORNI') {
    $('.consegna').html(estimateDelivery(8, lang, 0))
    // pausaEstivaMsg(lang, '7 - 10 giorni');
    // xmasNoShipMsg(lang);
  } else if (delivery === '10 / 15 GIORNI') {
    $('.consegna').html(estimateDelivery(11, lang, 0))
    // pausaEstivaMsg(lang, '10 - 15 giorni');
    // xmasNoShipMsg(lang);
  } else if (delivery === '20-25 GIORNI') {
    $('.consegna').html(estimateDelivery(21, lang, 0))
    // pausaEstivaMsg(lang, '20 - 25 giorni');
    // xmasNoShipMsg(lang);
  } else if (
    delivery === 'DAL 11 SETTEMBRE' ||
    delivery === 'DAL 1 SETTEMBRE'
  ) {
    pausaEstivaMsg(lang, '7 - 10 giorni')
  } else if (delivery === '0') {
    if (lang === 'it') {
      // eslint-disable-line no-lonely-if
      $('.consegna')
        .parent()
        .html(
          'ARTICOLO AL MOMENTO NON DISPONIBILE, <a class="aside-open" data-target="popup-unavailable" href="javascript:void(0);" style="font-weight:700; color:#333;">CONTATTACI</a> PER MAGGIORI INFORMAZIONI'
        )
    } else if (lang === 'en') {
      $('.consegna')
        .parent()
        .html(
          'ITEM NOT AVAILABLE AT THE MOMENT, <a class="aside-open" data-target="popup-unavailable" href="javascript:void(0);" style="font-weight:700; color:#333;">CONTACT US</a> FOR MORE INFORMATIONS'
        )
    }
  } else {
    $('.consegna').parent().html('')
  }
})()
